function digitsOnly(value: string) {
  return value.replace(/\D/g, '');
}

export function formatUsPhone(value: string) {
  const digits = digitsOnly(value).slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function isValidUsPhone(value: string) {
  return /^\(\d{3}\) \d{3}-\d{4}$/.test(value);
}

/**
 * Convert display format (305) 555-1234 to E.164 format +13055551234
 */
export function toE164(displayPhone: string): string {
  const digits = digitsOnly(displayPhone);
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  return displayPhone;
}

/**
 * Convert E.164 format +13055551234 to display format (305) 555-1234
 */
export function fromE164(e164Phone: string): string {
  const match = e164Phone.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return e164Phone;
}
